import styles from './AdminSidebar.module.scss';
import AdminSidebarItemList from './AdminSidebarItemList';
import { ReactNode } from 'react';

interface AdminSidebarProps {
  sideBarContent?: ReactNode;
}

const AdminSidebar = ({ sideBarContent }: AdminSidebarProps) => {
  return (
    <aside className={`${styles.sidebar} ${styles.sidebar__expanded}`}>
      <AdminSidebarItemList />
      {sideBarContent}
    </aside>
  );
};

export default AdminSidebar;
